import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { viewUserProfile } from 'modules/app';
import Searcher from '../components/Searcher';
import { setQueryString, search } from '../modules/searcher';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.searcher || {},
    q: state.searcher.q,
    results: state.searcher.results,
    isLoading: state.searcher.isLoading,
    app: state.app,
    canLoadMore: state.searcher.canLoadMore,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setQueryString: bindActionCreators(setQueryString, dispatch),
    search: bindActionCreators(search, dispatch),
    viewUserProfile: bindActionCreators(viewUserProfile, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Searcher));



// WEBPACK FOOTER //
// ./src/components/Searcher/container/index.js